/** API field mapping for director-dashboard-booking-summary / zone-wise-breakdown */

export const BOOKING_BUSINESS_FIELDS = {
  Retail: "retail_total_charges_with_gst",
  Credit: "credit_total_charges_with_gst",
  "DP Client": "dp_client_total_charges",
  "Piece Rate": "piece_rate_total_charges",
};

export const BOOKING_SHIPMENT_FIELDS = {
  Retail: "retail_shipments",
  Credit: "credit_shipments",
  "DP Client": "dp_client_shipments",
  "Piece Rate": "piece_rate_shipments",
};

export const getBookingFieldValue = (data, label, reportCategory) => {
  const fieldMap = reportCategory === "Business Data"
    ? BOOKING_BUSINESS_FIELDS
    : BOOKING_SHIPMENT_FIELDS;
  const field = fieldMap[label];
  return field ? (data[field] || 0) : 0;
};
